import {
  getPatientDetailsById,
  getPatientsByFilter,
  getPatientsByFirstCharacter,
  newPatient,
  showPatientsSubMenus,
} from './actions/PatientActions';
import { change, Field, reduxForm } from 'redux-form';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { renderCheckBox } from '../../components/reduxFields';
import { showFormatedDate, base64Encode, base64Decode } from '../../actions/utilAction';
import Avatar from 'material-ui/Avatar';
// import avatar from '../../img/uxceo-128.jpg';
// import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import Loader from '../../img/loader.gif';
// import user1 from '../../img/doctor.png';
import history from '../../history';

const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

class PatientQuickSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChar: '',
      patientdata: [],
      searchType: 'GET_TRUE',
      prevType: 'GET_TRUE',
      filter: 'startwith',
      searchText: '',
      type: 'GET_ALL',
      openAdvanceSearch: false,
      ActiveClient: false,
      InactiveClient: false,
      ShowClientsOfAllLocations: false,
    };
    this.onClickAlphabet = this.onClickAlphabet.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.renderPatients = this.renderPatients.bind(this);
    this.getPatientById = this.getPatientById.bind(this);
    this.onPatientClick = this.onPatientClick.bind(this);
    this.hideSidebar = this.hideSidebar.bind(this);
    this.handleAdvanceSearchClick = this.handleAdvanceSearchClick.bind(this);
    this.addClient = this.addClient.bind(this);
  }

  loadPatients() {
    let type = this.state.type;
    if (type === 'GET_FALSE') {
      this.setState({ prevType: this.state.searchType });
    }
    if (type) {
      this.setState({ searchType: type });
    } else {
      type = this.state.searchType;
    }
    if (this.props.currentLocationId) {
      let currentLocationId =  this.state.ShowClientsOfAllLocations ? '0' : this.props.currentLocationId;

      if (type === 'GET_ALL') {
        this.props.getPatientsByFilter(this.state.filter, this.state.searchText, '', currentLocationId, false, this.props.viewTeamClientsOnlyPermission);
      } else if (type === 'GET_TRUE') {
        let advancedFilter = '&isactive=true';
        this.props.getPatientsByFilter(this.state.filter, this.state.searchText, advancedFilter, currentLocationId, false, this.props.viewTeamClientsOnlyPermission);
      } else {
        let advancedFilter = '&isactive=false';
        this.props.getPatientsByFilter(this.state.filter, this.state.searchText, advancedFilter, currentLocationId, false, this.props.viewTeamClientsOnlyPermission);
      }
    }
  }

  componentWillMount() {
    // this.loadPatients('startwith', '', 'GET_ALL');
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.patientdata && this.props.patientdata !== nextProps.patientdata) {
    //   let patientdata = nextProps.patientdata.data;
    //   this.setState({ patientdata: patientdata });
    // }
    if (nextProps.patientActiveStatus && nextProps.patientActiveStatus !== this.props.patientActiveStatus) {
      this.loadPatients();
    }
    if (nextProps.clientLockStatus && nextProps.clientLockStatus !== this.props.clientLockStatus) {
      this.loadPatients();
    }

  }

  onClickAlphabet(e) {
    let char = e.target.id;
    this.setState({ filter: 'startwith', searchText: char, activeChar: char }, () => this.loadPatients());
  }

  onSearch(value) {
    let filter, searchText, type;
    if (value.trim().length >= 3) {
      filter = 'searchKey';
      searchText = value;
      this.setState({ filter, searchText }, () => this.loadAdvanceSearchFilters());
    } else if (value.length === 0) {
      filter = 'startwith';
      searchText = '';
      type = 'GET_TRUE';
      this.setState({ filter, searchText, type }, () => this.loadAdvanceSearchFilters());
    }
  }

  handleNewPatientClick = () => {
    this.props.newPatient();
  }


  handleAdvanceSearchClick = () => {
    this.setState({ openAdvanceSearch: !this.state.openAdvanceSearch });

    if (this.state.openAdvanceSearch) {
      this.props.dispatch(change('PatientQuickSearchForm', 'ActiveClient', false));
      this.props.dispatch(change('PatientQuickSearchForm', 'InactiveClient', false));
      this.setState({ ActiveClient: false, InactiveClient: false },
        () => {
          this.loadAdvanceSearchFilters();
        });
    }
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadAdvanceSearchFilters();
      });
  }

  loadAdvanceSearchFilters() {
    let filter, searchText, type;
    if (this.state.ActiveClient === true && this.state.InactiveClient === true) {
      filter = 'startwith';
      searchText = this.state.searchText ? this.state.searchText : this.state.activeChar;
      type = 'GET_ALL';
    } else if ((this.state.ActiveClient === true && this.state.InactiveClient === false) ||
      (this.state.ActiveClient === false && this.state.InactiveClient === false)) {
      filter = 'startwith';
      searchText = this.state.searchText ? this.state.searchText : this.state.activeChar;
      type = 'GET_TRUE';
    } else if (this.state.ActiveClient === false && this.state.InactiveClient === true) {
      filter = 'startwith';
      searchText = this.state.searchText ? this.state.searchText : this.state.activeChar;
      type = 'GET_FALSE';
    }
    this.setState({ filter, searchText, type }, () => this.loadPatients());
  }

  handleInactiveCheck = (input) => {
    let filter, searchText, type;
    if (input.target.checked) {
      filter = 'startwith';
      searchText = this.state.activeChar;
      type = 'GET_ALL';
    } else {
      filter = 'startwith';
      searchText = this.state.activeChar;
      type = 'GET_TRUE';
    }
    this.setState({ filter, searchText, type }, () => this.loadPatients());

  }

  handleOnlyInactiveCheck = (input) => {
    let filter, searchText, type;
    if (input.target.checked) {
      filter = 'startwith';
      searchText = this.state.activeChar;
      type = 'GET_FALSE';
    } else {
      filter = 'startwith';
      searchText = this.state.activeChar;
      type = this.state.prevType;
    }
    this.setState({ filter, searchText, type }, () => this.loadPatients());
  }

  renderLoading() {
    if (this.props.search_loading) {
      return (
        <div className="full_loader top0">
          <div className="circle_loader search_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  renderAlphabets() {
    let alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    return alphabets.map((char, index) => {
      return (
        <div
          key={index}
          id={char}
          onClick={this.onClickAlphabet}
          className={this.state.activeChar === char ? 'active' : ''}>
          {char}</div>
      );
    });
  }

  getPatientById(e, patientId) {
    e.preventDefault();
    this.props.getPatientDetailsById(patientId);
  }

  hideSidebar(e, url, patientId) {
    e.preventDefault();
    history.push(url + `${patientId}`);
    this.props.toggleSwitch();
  }

  addClient(e, url) {
    e.preventDefault();
    history.push(url);
    this.props.toggleSwitch();
  }

  // handlefavourites(patientId) {
  // let userId = this.props.loginUserInfo.userID;
  // this.props.addFavouriteAction(patientId, userId);
  // }

  onPatientClick(e, url, patientId) {
    e.preventDefault();
    this.props.showPatientsSubMenus(true);
    if (this.props.viewProfileSmryPermission) {
      this.hideSidebar(e, url, patientId);
    } else {
      patientId = base64Decode(patientId);
      this.props.getPatientDetailsById(patientId);
      this.props.toggleSwitch();
    }
  }

  renderPatients() {

    if (this.props.patientdata.length === 0) {
      return (
        <ListItem className="clientitem"
          primaryText="No client for current selected alphabet."
          insetChildren={true}
        ></ListItem>
      );
    }

    if (this.props.patientdata) {
      return this.props.patientdata.map((client, index) => {
        // console.log('client.........',client);
        let patId = base64Encode(`${client.patientId}`);
        let name = `${client.firstName} ${client.lastName}`;
        name = name.trim();        
        return (
          <NavLink
            key={index}
            onClick={(e) => this.onPatientClick(e, `/client/profile/`, patId)}
            to={this.props.viewProfileSmryPermission ? `/client/profile/${patId}` : ''}>
            <ListItem className="clientitem"
              primaryText={name}
              secondaryText={
                <span className="searchitem">
                  <font>{client.mrn === null ? 'Client ID: N/A' : `Client ID: ${client.mrn}`}</font>
                  <font>D.O.B : {client.dob ? showFormatedDate(client.dob) : '-'}</font>
                </span>
              }
              insetChildren={true}
            >

              {client.isActive && client.isBlock ?
                <span className='clientsearch_img activec lock'>
                  {client.photoThumbnailPath ? <Avatar src={client.photoThumbnailPath} className="img-fluid" /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
                : null}

              {client.isActive && client.isBlock === false ?
                <span className='clientsearch_img activec'>
                  {client.photoThumbnailPath ? <Avatar src={client.photoThumbnailPath} className="img-fluid" /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-circle" aria-hidden="true"></i>
                </span>
                : null}

              {client.isActive === false && client.isBlock ?
                <span className='clientsearch_img inactive lock'>
                  {client.photoThumbnailPath ? <Avatar src={client.photoThumbnailPath} className="img-fluid" /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
                : null}

              {client.isActive === false && client.isBlock === false ?
                <span className='clientsearch_img inactive'>
                  {client.photoThumbnailPath ? <Avatar src={client.photoThumbnailPath} className="img-fluid" /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-circle" aria-hidden="true"></i>
                </span>
                : null}

            </ListItem>
          </NavLink>
        );
      });
    }
  }

  onClientSearch = (e) => {
    e.preventDefault();
    return false;
  }

  render() {
    return (
      <div>
        <div className={this.props.addPermission ? 'searchwdbtn' : 'searchcross'} >
          <form className="searchclient" onSubmit={(e) => this.onClientSearch(e)}>
            <input type="text" className='pateintsearch' placeholder="Search here..." onChange={(e) => this.onSearch(e.target.value)} />
            <button className="serchclose-btn" onClick={(e) => this.onSearch('')} type="reset"><i className="fa fa-times" aria-hidden="true"></i></button>
          </form>
          <IconButton className="s_filter" onClick={this.handleAdvanceSearchClick}>
            <i className="fa fa-filter" aria-hidden="true"></i>
          </IconButton>
          {this.props.addPermission ?
            <NavLink to="/client" onClick={(e) => this.addClient(e, '/client')}>
              <button type="button" className="addpateint" /* onClick={this.handleNewPatientClick}*/>Add Client</button>
            </NavLink>
            : null
          }
        </div>
        {this.state.openAdvanceSearch ?
          <div className="filterbox" >
            <div className="row">
              <div className="col-12 filterhead">
                Advance Search Filter <i className="fa fa-times" aria-hidden="true" onClick={this.handleAdvanceSearchClick}></i>
              </div>
              <div className="col-12">
                <Field
                  name="ActiveClient"
                  label="Include active clients only"
                  component={renderCheckBox}
                  onChange={(e) => this.handleAdvanceFilterCheck(e, 'ActiveClient')}
                  style={stylescss.checkbox}
                />
              </div>
              <div className="col-12">
                <Field
                  name="InactiveClient"
                  label="Include inactive clients only"
                  component={renderCheckBox}
                  onChange={(e) => this.handleAdvanceFilterCheck(e, 'InactiveClient')}
                  style={stylescss.checkbox}
                />
              </div>
              <div className="col-12">
                <Field
                  name="ShowClientsOfAllLocations"
                  label="Clients in all locations"
                  component={renderCheckBox}
                  onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowClientsOfAllLocations')}
                  style={stylescss.checkbox}
                />
              </div>
            </div>
          </div>
          :
          ''
        }

        <div className="clientalpha">
          {this.renderAlphabets()}
        </div>
        <div className="clientlist">
          {this.renderLoading()}
          <List>
            {this.renderPatients()}
          </List>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // Start For Role Permission
  let userScreenPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_ADD')[0].permission : false;
  let viewProfileSmryPermission = hasDefaultAccess ? true : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_PROFILE')[0].permission : false;
  let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;
  // End For Role Permission

  let patientData = [];
  if (state.patient.get_patient_ByFilter && state.patient.get_patient_ByFilter.data) {
    patientData = state.patient.get_patient_ByFilter.data;
  }
  return {
    patientdata: patientData,
    loginUserInfo: state.login.loginUserInfo,
    search_loading: state.patient.search_loading,
    currentLocationId: state.login.currentLocationId,
    patientActiveStatus: state.patient.patientActiveStatus,
    clientLockStatus: state.patient.clientLockStatus,
    addPermission: addPermission,
    viewProfileSmryPermission: viewProfileSmryPermission,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
  };
}
PatientQuickSearch = reduxForm({
  form: 'PatientQuickSearchForm',
  enableReinitialize: true,
})(PatientQuickSearch);
export default connect(mapStateToProps, {
  newPatient,
  getPatientDetailsById,
  getPatientsByFirstCharacter,
  getPatientsByFilter,
  showPatientsSubMenus,
})(PatientQuickSearch);



// WEBPACK FOOTER //
// ./src/modules/patients/search_patient.js